module.exports = __webpack_public_path__ + "img/whatsapp-fixed.6e0e919c.svg";